import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../app/store";
import { error, failedResponse, getBackendUrl, INVALID_ID, loaded, loading, LoadStateInfo, notStarted } from "../common";
import { PresenceEnum, PresenceInfo } from "./model";
import { getToken } from "../../features/user/UserAvatar";

export interface PresenceChangeClassroomState {
    state: LoadStateInfo;
    request?: PresenceChangeClassroomRequest;
}
const initialState: PresenceChangeClassroomState = {
    state: notStarted(),
};
export interface PresenceChangeClassroomRequest {
    subjectPerformedId: number;
    present: PresenceEnum;
}
export const performPresenceChangeClassroom = createAsyncThunk(
    "performPresenceChangeClassroom",
    async (param: PresenceChangeClassroomRequest, thunkAPI) => {
        console.debug(`change presence for subjectPerformed ${param.subjectPerformedId} to status ${param.present}`);

        const response = await fetch(`${getBackendUrl()}/api/presence/classroom/change`, {
            method: "POST",
            signal: thunkAPI.signal,
            headers: {
                "Authorization": `Bearer ${getToken()}`,
                "Content-Type": "application/json",
            },
            body: JSON.stringify(param)
        });

        if (response.ok) {
            return await response.json();
        } else {
            return thunkAPI.rejectWithValue(failedResponse(response));
        }
    },
);

export const presenceChangeClassroomSlice = createSlice({
    name: "performPresenceChangeClassroom",
    initialState,
    reducers: {
        clear: (state, action: PayloadAction<PresenceChangeClassroomRequest>) => {
            state.request = undefined;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(performPresenceChangeClassroom.pending, (state, action) => {
                const payload = action.meta.arg;
                state.request = payload;
            })
            .addCase(performPresenceChangeClassroom.fulfilled, (state, action) => {
                state.state = loaded();
            })
            .addCase(performPresenceChangeClassroom.rejected, (state, action) => {
                const payload = action.meta.arg;
                state.state = error(action);
                state.request = payload;
            });
    },
});

export const selectPresenceChangeClassroom = (state: RootState) => state.presenceChangeClassroom;

export default presenceChangeClassroomSlice.reducer;
